<!--
自定义 switch 组件，label 会显示在中间
使用案例：
<lc-switch
    v-model="form.status"
    active-value="enabled"
    inactive-value="disabled"
    :active-text="已启用"
    :inactive-text="已禁用"
  />
-->
<template>
  <div class="lc-switch">
    <el-switch v-model="switchValue" :active-value="activeValue" :inactive-value="inactiveValue" :disabled="disabled"></el-switch>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Boolean],
      default: true
    },
    activeText: {
      type: String,
      default: ''
    },
    inactiveText: {
      type: String,
      default: ''
    },
    activeValue: {
      type: [String, Number, Boolean],
      default: true
    },
    inactiveValue: {
      type: [String, Number, Boolean],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      switchValue: 0
    }
  },
  computed: {
    /**
     * 选项显示的文字
     *
     * @returns {string} 选项文字
     */
    text() {
      if (this.value === this.activeValue) {
        return this.activeText
      }
      return this.inactiveText
    }
  },
  watch: {
    switchValue() {
      this.emitInputEvent()
    },
    // 当值改变时，替换文字
    value() {
      this.switchValue = this.value
      this._renderText()
    }
  },
  mounted() {
    this.switchValue = this.value
    this._renderText()
  },
  methods: {
    /**
     * 通知 v-model 值变化
     */
    emitInputEvent() {
      this.$emit('input', this.switchValue)
    },
    /**
     * 渲染文案
     */
    _renderText() {
      let switchCoreElement = this.$el.querySelector('.el-switch__core')
      switchCoreElement.innerHTML = `<span>${this.text}</span>`
    }
  }
}
</script>
<style lang="scss" scoped>
.lc-switch {
  display: inline-block;
  position: relative;

  ::v-deep .el-switch__core {
    width: 100% !important;
    min-width: 40px;

    span {
      margin-left: 25px;
      margin-right: 12px;
      font-size: 12px;
      vertical-align: top;
      display: inline-block;
      margin-top: -1px;
      color: gray;
    }
  }

  ::v-deep .is-checked {
    .el-switch__core {
      span {
        color: #fff;
        margin-left: 12px;
        margin-right: 25px;
      }
    }
  }
}
</style>
